import { render, staticRenderFns } from "./choose_partner_sex.vue?vue&type=template&id=21adf94e&scoped=true&"
import script from "./choose_partner_sex.vue?vue&type=script&lang=js&"
export * from "./choose_partner_sex.vue?vue&type=script&lang=js&"
import style0 from "./choose_partner_sex.vue?vue&type=style&index=0&id=21adf94e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adf94e",
  null
  
)

export default component.exports